import { useEffect, useState } from "react";
import { Link, useOutletContext } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { formatCurrency, formatDateTime, StatusPill } from "@/lib/utils-format";
import { Plus, Package } from "@phosphor-icons/react";

export default function CustomerOrders() {
  const { user } = useOutletContext();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/customer/orders").then((r) => setOrders(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="customer-orders-page">
      <div className="flex items-start justify-between mb-6">
        <div>
          <p className="text-[10px] uppercase tracking-[0.2em] text-zinc-500 font-semibold mb-1">Hi, {user?.name}</p>
          <h1 className="text-3xl font-black tracking-tighter">My Orders</h1>
        </div>
        <Link to="/customer/new">
          <Button className="bg-zinc-900 hover:bg-zinc-800 text-white rounded-md" data-testid="place-new-order">
            <Plus size={14} weight="bold" className="mr-1" /> Place new order
          </Button>
        </Link>
      </div>

      {loading ? (
        <p className="text-sm text-zinc-500">Loading your orders…</p>
      ) : orders.length === 0 ? (
        <div className="border border-dashed border-zinc-300 bg-white p-12 text-center">
          <Package size={32} className="mx-auto mb-3 text-zinc-400" />
          <p className="text-sm text-zinc-500 mb-4">You haven&apos;t placed any orders yet.</p>
          <Link to="/customer/new">
            <Button className="bg-zinc-900 hover:bg-zinc-800 text-white">Place your first order</Button>
          </Link>
        </div>
      ) : (
        <div className="border border-zinc-200 bg-white overflow-hidden">
          <table className="w-full data-table">
            <thead>
              <tr>
                <th className="text-left px-4 py-2.5">Order #</th>
                <th className="text-left px-4 py-2.5">Placed</th>
                <th className="text-left px-4 py-2.5">Product</th>
                <th className="text-right px-4 py-2.5">Amount</th>
                <th className="text-left px-4 py-2.5">Status</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {orders.map((o) => (
                <tr key={o.order_id} className="border-b border-zinc-100 hover:bg-zinc-50" data-testid={`my-order-${o.order_number}`}>
                  <td className="px-4 py-3 font-mono text-sm font-medium">{o.order_number}</td>
                  <td className="px-4 py-3 text-sm text-zinc-600">{formatDateTime(o.created_at)}</td>
                  <td className="px-4 py-3 text-sm">{o.product} <span className="text-zinc-500 text-xs">×{o.quantity}</span></td>
                  <td className="px-4 py-3 text-sm font-mono text-right">{formatCurrency(o.total_amount, o.currency)}</td>
                  <td className="px-4 py-3"><StatusPill status={o.status} /></td>
                  <td className="px-4 py-3 text-right">
                    <Link to={`/customer/orders/${o.order_id}`} className="text-xs uppercase tracking-widest text-zinc-500 hover:text-zinc-900" data-testid={`view-order-${o.order_number}`}>
                      View →
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
